import React from 'react';
import PropTypes from 'prop-types';
import { fieldInputPropTypes, fieldMetaPropTypes } from 'redux-form/immutable';

import formControl from './formControl';
import * as styles from './styles.css';

function InputGroup({
  disabled,
  isEditable,
  input: {
    value,
    onChange,
    onBlur,
    ...otherInputProps
  },
  placeholder,
  type,
  inputAddonAfter,
  defaultValue,
}) {
  if (isEditable === false) {
    return <div className={styles.value}>{value || defaultValue}{inputAddonAfter}</div>;
  }

  return (
    <div className={styles.inputGroup}>
      <input
        {...otherInputProps}
        className="form-control"
        value={value}
        disabled={disabled}
        type={type}
        placeholder={placeholder}
        onChange={event => onChange(event.target.value)}
        onBlur={event => onBlur(event.target.value)}
      />
      <div className="input-group-addon">{inputAddonAfter || (<i className="fa fa-spin fa-spinner" />)}</div>
    </div>
  );
}

InputGroup.defaultProps = {
  type: 'text',
  placeholder: '',
  defaultValue: '-',
  disabled: false,
  isEditable: true,
};

InputGroup.propTypes = {
  input: PropTypes.shape(fieldInputPropTypes).isRequired,
  meta: PropTypes.shape(fieldMetaPropTypes).isRequired,
  disabled: PropTypes.bool,
  isEditable: PropTypes.bool,
  type: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  inputAddonAfter: PropTypes.string.isRequired,
  defaultValue: PropTypes.string.isRequired,
};

export default formControl(InputGroup);
